import { t } from 'i18next';
import { useFormContext } from 'react-hook-form';

import { GrantsModule } from './types';

import Grid from '@mui/material/Grid';

import {
  ControlledCheckbox,
  ControlledTextField
} from 'components/shared/ControlledFields';

const ModuleDataSection = () => {
  const { control } = useFormContext<GrantsModule>();

  return (
    <Grid container direction={'column'} spacing={2} mt={2}>
      <Grid item>
        <ControlledTextField
          control={control}
          disabled
          name="grantName"
          label={t('grants.modules.grid.grantName')}
        />
      </Grid>
      <Grid item>
        <ControlledCheckbox
          control={control}
          name="enabled"
          label={t('grants.modules.grid.enabled')}
        />
      </Grid>
    </Grid>
  );
};

export default ModuleDataSection;
